export default __webpack_public_path__ + "static/media/blog-2.9b285c96.jpg";